import { NON_BRAND_SUBDOMAIN_LABELS } from './nonBrandSubdomains.mjs';

// gloss
const APPLY_SUBDOMAINS = new Set(['apply', 'applystaging']);

// gloss
export const NON_BRAND_SUBDOMAINS: ReadonlySet<string> = new Set(NON_BRAND_SUBDOMAIN_LABELS);

// gloss
const HUB_DOMAIN_SUFFIX = '.joinzealot.com';

const hubSubdomain = (rawHost: string | null | undefined): string | undefined => {
  if (!rawHost) return undefined;

  let hostname: string;
  try {
    hostname = rawHost.includes('://') ? new URL(rawHost).hostname : (rawHost.split('/')[0]?.split(':')[0] ?? '');
  } catch {
    return undefined;
  }

  hostname = hostname.toLowerCase();
  if (!hostname.endsWith(HUB_DOMAIN_SUFFIX)) return undefined;

  const parts = hostname.split('.');
  if (parts.length <= 2) return undefined;

  return parts[0] || undefined;
};

// gloss
export const brandLabelFromHost = (rawHost: string | null | undefined): string | undefined => {
  const subdomain = hubSubdomain(rawHost);
  if (!subdomain || NON_BRAND_SUBDOMAINS.has(subdomain)) return undefined;

  return subdomain;
};

// gloss
export const isApplyHost = (rawHost: string | null | undefined): boolean => {
  const subdomain = hubSubdomain(rawHost);
  return Boolean(subdomain && APPLY_SUBDOMAINS.has(subdomain));
};
